<template>
    <v-dialog persistent max-width="550" :key="componentKey" v-model="commentsDialog">
        <v-card style="background-color: #07575b" >
            <v-card-title class="justify-center "  >
                <v-spacer/>
                <span class="headline white--text"> Σχόλια </span>
                <v-spacer/>
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <v-icon large v-on="on" class="pt-1"
                                color="white">mdi-help-circle-outline
                        </v-icon>
                    </template>
                    <span> Προσθήκη σχολίων αναφορικά με τα δεδομένα κοστολόγησης.</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text style="background-color: rgb(212,213,210)">
                <v-form class="pt-4" v-model="commentsFormValid">
                    <v-textarea
                            auto-grow counter
                            row-height="5" clearable
                            :rules="commentsRules"
                            label="Σχόλια κοστολόγησης"
                            v-model="comments">
                    </v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions style="background-color: rgb(212,213,210)" class="justify-center pa-0 pb-2">

                <v-btn style="min-width: 150px" @click="closeCommentsDialog"  color="white" > Άκυρο </v-btn>
                <v-btn style="min-width: 150px" @click="saveCommentForRequest" :disabled="readOnlyMode ? true : !commentsFormValid" color="primary" > ΟΚ</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "CommentsDialog",
        data: () => ({
            commentsFormValid: false,
            comments:'',
            initialUserInput:'',
            commentsRules: [v => v.length <= 1000 || 'Τα σχόλια μπορούν να έχουν μήκος 1000 χαρακτήρες'],
            commentsDialog: false,
        }),
        props:{
            componentKey: Number,
            commentInput: String,
            readOnlyMode:Boolean
        },

        methods:{
            closeCommentsDialog(){
                this.comments = this.initialUserInput;
                this.$emit('input', this.comments);
                this.commentsDialog = false;
            },

            saveCommentForRequest(){
                this.$emit('input', this.comments);
                this.commentsDialog = false;
            },
        },
        watch: {
            'componentKey': function () {
                this.initialUserInput = this.commentInput;
                this.comments = this.commentInput;
                this.commentsDialog = true;
            },
        }
    }
</script>

<style scoped>

</style>